import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseCoreState, baseSharedActions, baseSharedSelectors } from 'base';

@Injectable({ providedIn: 'root' })
export class BaseCustomerDepartmentsGuard {
  constructor(private readonly store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const active = route.data['loadAllDepartments'] ? undefined : true;

    this.store.dispatch(baseSharedActions.loadCustomerDepartmentList({ payload: { active } }));

    return this.store.select(baseSharedSelectors.getDepartments).pipe(
      filter((response) => response.ok !== undefined),
      map((response) => !!response.ok)
    );
  }
}
